import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import LFP from '@elem/SVGIcon/VanlifeRoadtrips/LFP';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('vanliferoadtrips');
    const LOCAL_SITES: string[] = ['za', 'uk', 'kr'];
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
    const icons: any = [
        {
            icon: <PortableDesign />,
            text: t('secD_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secD_tag2'),
        },
        {
            icon: <LFP />,
            text: t('secD_tag3'),
        },
    ];
    return (
        <div id="vanlife-roadtrips-D" className={`vanlife-roadtrips-D ${css['vanlife-roadtrips-D']}`}>
            <div className="img-box">
                <EFPicture
                    src={
                        ['au'].includes(locale)
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716544636037/4_au.png'
                            : `/responsive/picture/vanlife-roadtrips/4${
                                  LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES?.includes(locale) ? '_eu' : ''
                              }.jpg`
                    }
                    srcMobile={
                        ['au'].includes(locale)
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716544625553/4_375_au.png'
                            : `/responsive/picture/vanlife-roadtrips/4_375${
                                  LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES?.includes(locale) ? '_eu' : ''
                              }.jpg`
                    }
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
